export default {"src":"/_next/static/media/small-tooltip.bd860809.svg","height":16,"width":16};